<template>
  <main :class="$style.page">
    <ServiceUnavailableScreen
      v-if="isDepartmentResolved && shouldShowServiceUnavailable"
      :department="department"
    />
    <router-view v-else-if="isDepartmentResolved" />
    <SectionLoader v-else :active="true" fill />
  </main>
</template>

<script>
import SectionLoader from "@/components/common/SectionLoader.vue";
import ServiceUnavailableScreen from "@/components/common/ServiceUnavailableScreen.vue";
import { mapState } from "vuex";

export default {
  name: "AppRoot",
  components: {
    SectionLoader,
    ServiceUnavailableScreen,
  },
  data() {
    return {
      isDepartmentResolved: false,
    };
  },
  computed: {
    ...mapState({
      department: (state) => state.department.department,
    }),
    isQueueMode() {
      const type = Array.isArray(this.$route?.query?.type)
        ? this.$route.query.type[0]
        : this.$route?.query?.type;
      return String(type || "").toLowerCase() === "queue";
    },
    isOrderProcessingUnavailable() {
      return this.department?.combine_order_processing_mode === false;
    },
    shouldShowServiceUnavailable() {
      if (!this.isOrderProcessingUnavailable) {
        return false;
      }

      if (this.$route?.name === "orders") {
        return false;
      }

      if (this.$route?.name === "requests" && this.isQueueMode) {
        return false;
      }

      return true;
    },
  },
  async mounted() {
    document.title = "Calculator Requests";
    await this.$store.dispatch("department/fetchDepartment");
    this.isDepartmentResolved = true;
  },
};
</script>

<style lang="scss" module>
.page {
  min-height: 100vh;
  background-color: $bg-primary;
}
</style>
